"use strict";

import { on } from '@elements/dom-utils';
import {onFind} from '@elements/init-modules-in-scope';

export function init() {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        onFind('.js-rerender-item', element => {
            on('load', () => {
                element.style.display = 'none';
                setTimeout(() => {
                    element.style.display = 'block';
                }, 1)
            }, window);
        });
    }
}